import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Fontes auto-hospedadas: sem requisicao a terceiros, sem bloqueio de
// renderizacao e sem deslocamento de layout quando a fonte carrega. IBM Plex Sans
// pelos numerais tabulares, que importam em toda tela financeira; IBM Plex Mono
// para codigo, documento e valor em coluna.
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';

import './globals.css';
import { App } from './app';
import { AuthProvider } from '@/lib/auth';
import { ToastProvider } from '@/components/ui';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Elemento #root ausente no index.html.');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>,
);
